import { render, staticRenderFns } from "./SeguimientoTab.vue?vue&type=template&id=8e1b2ae2&scoped=true&lang=pug"
import script from "./SeguimientoTab.vue?vue&type=script&lang=js"
export * from "./SeguimientoTab.vue?vue&type=script&lang=js"
import style0 from "./SeguimientoTab.vue?vue&type=style&index=0&id=8e1b2ae2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e1b2ae2",
  null
  
)

export default component.exports